import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useScrollToSection } from '../hooks/useScrollToSection';
import './MobileMenu.css';

const MobileMenu = ({ open, onClose }) => {
  const scrollToSection = useScrollToSection();

  useEffect(() => {
    document.body.classList.toggle('no-scroll', open);
    return () => document.body.classList.remove('no-scroll');
  }, [open]);

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    scrollToSection(sectionId, onClose);
  };

  if (!open) return null;

  return (
    <div className="mm" role="dialog" aria-modal="true">
      <button className="mm__backdrop" aria-label="Close menu" onClick={onClose} />
      <div className="mm__panel">
        <div className="mm__header">
          <Link to="/" className="mm__brand" onClick={onClose}>
            <img src="/img/nintschew_logo_2.png" alt="Nintschew & Partner Logo" />
          </Link>
          <button className="mm__close" aria-label="Close menu" onClick={onClose}>
            <span />
            <span />
          </button>
        </div>
        <nav className="mm__nav">
          <a href="#about" className="mm__link" onClick={(e) => handleNavClick(e, '#about')}>Über uns</a>
          <a href="#team" className="mm__link" onClick={(e) => handleNavClick(e, '#team')}>Team</a>
          <a href="#services" className="mm__link" onClick={(e) => handleNavClick(e, '#services')}>Leistungen</a>
          <Link to="/news" className="mm__link" onClick={onClose}>News</Link>
          <a href="#contact-form" className="mm__cta" onClick={(e) => handleNavClick(e, '#contact-form')}>Anfrage senden</a>
        </nav>
        
        {/* Contact & Social Section */}
        <div className="mm__footer">
          <div className="mm__contact">
            <div className="mm__contact-item">
              <a href="mailto:office@nintschew-partner.at" className="mm__contact-link">
                <span>office@nintschew-partner.at</span>
              </a>
            </div>
            <div className="mm__contact-item">
              <a href="tel:+4312880744" className="mm__contact-link">
                <span>+43 1 288 07 44</span>
              </a>
            </div>
          </div>
          
          <div className="mm__social">
            <h4 className="mm__social-title">Folgen Sie uns</h4>
            <div className="mm__social-links">
              <a href="https://www.facebook.com/NintschewPartner/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="mm__social-btn">
                <img src="/img/facebook.svg" alt="Facebook" />
              </a>
              <a href="https://www.instagram.com/nintschew_partner/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="mm__social-btn">
                <img src="/img/instagram.svg" alt="Instagram" />
              </a>
              <a href="https://www.linkedin.com/company/nintschew-partner-steuer-und-wirtschaftsberatung/?originalSubdomain=at" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="mm__social-btn">
                <img src="/img/linkedin.svg" alt="LinkedIn" />
              </a>
            </div>
          </div>
          
          <div className="mm__legal">
            <Link to="/impressum" className="mm__legal-link" onClick={onClose}>Impressum & AAB</Link>
            <a href="#datenschutz" className="mm__legal-link" onClick={onClose}>Datenschutz</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;


